{
  "name": "ngx-student-portal",
  "version": "0.12.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy.conf.json",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/platform-browser": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@ngx-formly/core": "^6.0.0",
    "date-fns": "^2.29.2",
    "lodash-es": "^4.18.1",
    "ng-zorro-antd": "^21.3.3",
    "rxjs": "~7.5.6",
    "signature_pad": "^4.2.0",
    "tslib": "^2.4.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.29",
    "@angular/cli": "~21.2.29",
    "@angular/compiler-cli": "^21.2.25",
    "@types/lodash-es": "^4.17.3",
    "ngx-build-plus": "^14.0.0",
    "typescript": "~5.9.3"
  }
}
